// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"678":"c170f372","821":"b3b50477"}[chunkId] + ".chunk.js";
};